export default __webpack_public_path__ + "static/media/chat-icon.f05eb884.svg";